
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(d8|fj|s|u)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
